// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_et-j";
export var fulfillmentFormRail = "_et-i";
export var headerTitleRow = "_et-l";
export var orderDetailsWrapper = "_et-g";
export var orderLinkTrigger = "_et-2";
export var paymentInformationGrid = "_et-q";
export var paymentSummaryColumn = "_et-r";
export var phoneShipmentPickerButton = "_et-e";
export var phoneShipmentPickerButtonContent = "_et-f";
export var phoneShipmentPickerButtonWrapper = "_et-d";
export var phoneShipmentPickerTrigger = "_et-c";
export var shipmentContainer = "_et-k";
export var shipmentDetailsMainPane = "_et-h";
export var shipmentNavigationCard = "_et-a";
export var shipmentNavigationEdgeTrigger = "_et-6";
export var shipmentNavigationRail = "_et-3";
export var shipmentNavigationRailEnter = "_et-5";
export var shipmentNavigationRailHeader = "_et-9";
export var shipmentNavigationRailOverlay = "_et-4";
export var shipmentNavigationScrim = "_et-7";
export var shipmentSummaryFact = "_et-n";
export var shipmentSummaryGrid = "_et-m";
export var shipmentSummaryMetadataRow = "_et-o";
export var shipmentSummaryTags = "_et-p";
export var shipmentWorkspace = "_et-0";
export var shipmentWorkspaceBodyTablet = "_et-8";
export var shipmentWorkspaceContent = "_et-b";
export var shipmentWorkspaceHeader = "_et-1";